import { Box } from '@mantine/core';
import type { ReactNode } from 'react';

interface ServiceTabProps {
  readonly children: ReactNode;
}

// Фирменный «таб»-ярлык раздела (зелёный прямоугольник с белым текстом) — узнаваемый мотив оригинала.
export default function ServiceTab({ children }: ServiceTabProps) {
  return (
    <Box bg="brand.6" c="white" fw={600} fz="sm" w="fit-content" px="sm" py={6}>
      {children}
    </Box>
  );
}
